import "@hprofits/api/common/errors";
import { ORPCError as i } from "@orpc/client";
import { ValidationError as s } from "@orpc/contract";
import { ApiClientError as o, RequestCancelledError as E, RequestPayloadValidationError as c, ResponsePayloadValidationError as u, ApiError as f, HttpError as R } from "../../../errors/errors.js";
import "../../../errors/utils.js";
const d = "Unexpected HTTP error", p = "unknown", l = "UNKNOWN", N = (n) => n instanceof i && n.code === "BAD_REQUEST" && n.cause instanceof s, O = (n) => n instanceof i && n.defined && n.data != null, w = (n, { method: t, url: a } = { method: l, url: p }, e) => {
  if (e?.aborted && !(n instanceof o))
    return new E(t, a, { cause: n });
  if (N(n))
    return new c(t, a, n.cause);
  if (n instanceof s)
    return new u(t, a, n);
  if (O(n))
    return new f(t, a, n.status, n.code, n.message, n.data, { cause: n });
  if (n instanceof i)
    return new R(t, a, n.status, n.message || d, { cause: n });
};
export {
  w as toClientError
};
//# sourceMappingURL=to-client-error.js.map
